import * as React from 'react';

interface ConfirmationModalProps {
  handleHideModal: () => void;
  handleEndSetup: (any) => void;
  showModal: boolean;
  header: string;
  question: string;
  content: string;
  cancelText: string;
  confirmText: string;
  buttonColor: string;
}

export const ConfirmationModal = ({
  handleHideModal,
  showModal,
  handleEndSetup,
  header,
  question,
  content,
  cancelText,
  confirmText,
  buttonColor,
}: ConfirmationModalProps) =>
  (
    <div className={showModal ? 'confirmation-modal' : 'confirmation-modal hide'}>
      <div className="confirmation-modal-container-wrap">
        <div className="confirmation-modal-container">
          <div className="content">
            <h2>{header}</h2>
            <br />
            <p>
              {question}
              <br />
              {content}
            </p>
          </div>
          <div className="flex-end">
            <button
              type="button"
              className="button pale-green md"
              onClick={handleHideModal}
            >
              {cancelText}
            </button>
            <button
              type="button"
              className={`confirmation-button button md ${buttonColor}`}
              onClick={handleEndSetup}
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
